(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else factory().mount(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  function createPublisher(options) {
    if (!options || options.enabled !== true || typeof options.qa !== 'boolean' || !options.payload || !options.api || typeof options.api.track !== 'function' || typeof options.api.isIdentified !== 'function') return null;
    var stopped = false;
    function allowed() { try { return !stopped && options.allowed() === true && options.online() === true; } catch (_) { return false; } }
    return {
      publish: async function (snapshot, handoff) {
        if (handoff && (typeof handoff.canSubmit !== 'function' || typeof handoff.markSubmitted !== 'function')) return false;
        function canSubmit() { return allowed() && (!handoff || handoff.canSubmit()); }
        if (!snapshot || !canSubmit()) return false;
        var recognized = await options.api.isIdentified();
        if (recognized !== true || !canSubmit()) return false;
        var now = options.now();
        if (now - snapshot.captured_at > 10000) return false;
        var props = options.payload.properties(snapshot, now, options.qa);
        if (!props) return false;
        var eventId = options.uuid();
        if (typeof eventId !== 'string' || !/^[a-zA-Z0-9-]{16,80}$/.test(eventId)) return false;
        var event = Object.assign({}, props, { '$event_id': eventId, LL_Capture_Source: options.qa ? 'browser-auto-qa-v1' : 'browser-production-v1', LL_Capture_Attempted_At: new Date(now).toISOString() });
        if (!canSubmit() || (handoff && handoff.markSubmitted() !== true)) return false;
        options.report({ status: 'submitted', eventId: eventId, capturedAt: snapshot.captured_at, state: snapshot.state, itemCount: snapshot.item_count });
        try {
          var accepted = await options.api.track(options.payload.metricName, event);
          if (!stopped) options.report({ status: accepted === true ? 'acknowledged' : 'unconfirmed', eventId: eventId, capturedAt: snapshot.captured_at, state: snapshot.state, itemCount: snapshot.item_count });
          return accepted === true;
        } catch (_) {
          if (!stopped) options.report({ status: 'unconfirmed', eventId: eventId, capturedAt: snapshot.captured_at, state: snapshot.state, itemCount: snapshot.item_count });
          return false;
        }
      },
      stop: function () { stopped = true; }
    };
  }
  function mount(win) {
    if (!win || !win.document) return null;
    var host = win.document.querySelector('[data-ll-cart-capture]');
    if (!host || host.dataset.mounted) return null;
    var qa = host.dataset.llCartCapture === 'qa';
    if (!qa && host.dataset.llCartCapture !== 'production') return null;
    if (qa && new URLSearchParams(win.location.hash.slice(1)).get('ll_capture_auto') !== '1') return null;
    host.dataset.mounted = 'true';
    var controller = null, publisher = null, suspended = false, disposed = false;
    var preparing = null, generation = 0, retryTimer = null, retries = 0;
    function allowed() {
      try {
        var privacy = win.Shopify && win.Shopify.customerPrivacy;
        return !disposed && !suspended && win.navigator.onLine === true && !!privacy &&
          privacy.marketingAllowed() === true && privacy.analyticsProcessingAllowed() === true;
      } catch (_) { return false; }
    }
    function bounded(operation) {
      return new Promise(function (resolve, reject) {
        var timer = win.setTimeout(function () { reject(new Error('Unavailable')); }, 10000);
        Promise.resolve().then(operation).then(function (value) { win.clearTimeout(timer); resolve(value); }, function (error) { win.clearTimeout(timer); reject(error); });
      });
    }
    function loadAsset(source, ready) {
      if (ready()) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        var url;
        try {
          url = new URL(source, win.location.href);
          if (url.protocol !== 'https:' || url.username || url.password || !['lushlemon.com', 'lushlemon1.myshopify.com', 'cdn.shopify.com'].includes(url.hostname)) throw new Error('Invalid asset');
        } catch (_) { reject(new Error('Invalid asset')); return; }
        var script = win.document.createElement('script');
        script.src = url.href; script.async = false;
        script.onload = function () { ready() ? resolve() : reject(new Error('Unavailable')); };
        script.onerror = function () { reject(new Error('Unavailable')); };
        win.document.head.appendChild(script);
      });
    }
    function privacyReady() {
      if (win.Shopify && win.Shopify.customerPrivacy) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        if (!win.Shopify || typeof win.Shopify.loadFeatures !== 'function') return reject(new Error('Unavailable'));
        win.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function (error) { error ? reject(error) : resolve(); });
      });
    }
    function halt() {
      generation++;
      preparing = null;
      win.clearTimeout(retryTimer); retryTimer = null;
      if (controller) controller.stop();
      if (publisher) publisher.stop();
      controller = null; publisher = null;
    }
    function retry() {
      if (!disposed && !suspended && retries++ < 12 && !retryTimer) {
        retryTimer = win.setTimeout(function () { retryTimer = null; wake(); }, 1000);
      }
    }
    async function start() {
      var current = generation;
      try {
        await bounded(privacyReady);
        if (current !== generation || !allowed()) return;
        var sdk = win.klaviyo;
        if (!sdk || typeof sdk.track !== 'function' || typeof sdk.isIdentified !== 'function') { retry(); return; }
        if (await bounded(function () { return sdk.isIdentified(); }) !== true) { retry(); return; }
        if (current !== generation || !allowed()) return;
        await bounded(function () { return loadAsset(host.dataset.coreUrl, function () { return !!win.LushLemonCartSnapshot; }); });
        await bounded(function () { return loadAsset(host.dataset.payloadUrl, function () { return !!win.LushLemonCartEventPayload; }); });
        if (current !== generation || !allowed()) return;
        publisher = createPublisher({enabled:true, qa:qa, payload:win.LushLemonCartEventPayload, api:sdk,
          now:Date.now, allowed:allowed, online:function () { return win.navigator.onLine === true; },
          uuid:function () { return win.crypto.randomUUID(); }, report:function (result) {
            host.dataset.status = result.status;
            if (qa) { host.dataset.eventId = result.eventId; host.dataset.cartState = result.state; }
          }});
        controller = win.LushLemonCartSnapshot.browserAdapter(win,{enabled:true,publish:publisher.publish});
        if (!controller) { halt(); return; }
        retries = 0;
        await controller.refresh();
      } catch (_) { if (current === generation) retry(); }
    }
    function wake() {
      if (disposed || suspended) return Promise.resolve();
      if (controller) return controller.refresh();
      if (preparing) return preparing;
      var operation = start().finally(function () { if (preparing === operation) preparing = null; });
      preparing = operation;
      return preparing;
    }
    function consent() { halt(); retries = 0; wake(); }
    function offline() { suspended = true; halt(); }
    function resume() { suspended = false; retries = 0; wake(); }
    function visibility() { if (win.document.visibilityState === 'visible') wake(); }
    function formSubmitted(event) {
      if (event.detail && event.detail.type === 'submit') { retries = 0; wake(); retry(); }
    }
    var bindings = [
      [win.document,'visitorConsentCollected',consent],
      [win.document,'ajaxProduct:added',wake], [win.document,'cart:updated',wake],
      [win.document,'visibilitychange',visibility], [win,'klaviyoForms',formSubmitted],
      [win,'offline',offline], [win,'online',resume], [win,'pagehide',offline], [win,'pageshow',resume]
    ];
    bindings.forEach(function (entry) { entry[0].addEventListener(entry[1],entry[2]); });
    wake();
    return {refresh:wake, stop:function () {
      disposed = true; halt();
      bindings.forEach(function (entry) { entry[0].removeEventListener(entry[1],entry[2]); });
    }};
  }
  return {createPublisher:createPublisher,mount:mount};
});
